import type { Dictionnaire } from '../type';

export const fil: Dictionnaire['fil'] = {
  erreurs: {
    supprimerLesSiens: 'Solo puedes borrar tus propias publicaciones',
    pasTaReponse: 'Esta respuesta no es tuya',
    commentaireVide: 'Comentario vacío',
    vide: 'Escribe algo antes de publicar',
    tropLong: (max: number) => `${max} caracteres como máximo`,
  },
  commun: {
    retirerLike: 'Quitar el me gusta',
    liker: 'Me gusta',
    likerReponse: 'Me gusta esta respuesta',
    retirerSignet: 'Quitar de guardados',
    enregistrer: 'Guardar',
    actionsPost: 'Acciones de la publicación',
    actionsReponse: 'Acciones de la respuesta',
    voirPhoto: 'Ver la foto a pantalla completa',
    photoDe: (auteur: string) => `Foto publicada por ${auteur}`,
    supprimerPostQ: '¿Borrar esta publicación?',
    supprimerPost: 'Borrar esta publicación',
    supprimerReponseQ: '¿Borrar esta respuesta?',
    supprimerReponse: 'Borrar esta respuesta',
    signaler: 'Denunciar el contenido',
    partager: 'Compartir',
    suppressionImpossible: 'No se ha podido borrar.',
    reponses: 'Respuestas',
    commenter: 'Comentar',
  },
  signets: {
    onglets: {
      posts: 'Publicaciones',
      evenements: 'Eventos',
    },
    titre: 'Mis guardados',
    aucunPost: 'Ninguna publicación guardada',
    aucunPostAide: 'Guarda una publicación o una respuesta para encontrarla aquí.',
    aucuneSortie: 'Ningún evento guardado',
    aucuneSortieAide: 'Pulsa el marcador en la ficha de un evento para tenerlo a mano.',
    compte: (n: number) => `${n} guardado${n === 1 ? '' : 's'}`,
  },
  cloche: {
    verbes: {
      like: 'le ha gustado tu publicación',
      commentaire: 'ha respondido a tu publicación',
      mention: 'te ha mencionado en una publicación',
      signet: 'ha guardado tu publicación',
    },
    titre: 'Notificaciones',
    activite: 'Actividad',
    vide: 'Todavía no hay actividad',
    nouvelles: (n: number) => `Notificaciones · ${n} nuevas`,
  },
  composeur: {
    annulerReponse: 'Dejar de responder a esta respuesta',
    ecrire: 'Escribe un comentario...',
    envoyer: 'Enviar',
    reponseA: 'Respondiendo a',
    repondreA: (nom: string) => `Responder a ${nom}...`,
  },
  reponse: {
    voirReponses: (n: number) => `Ver las ${n} respuestas`,
    repondreA: (nom: string) => `Responder a ${nom}`,
  },
  fil: {
    envoiImpossible: 'No se ha podido enviar la respuesta',
    partagerReponse: 'Compartir esta respuesta',
    vide: 'Ninguna respuesta',
    videAide: 'Sé el primero en responder a este comentario.',
  },
  commentaires: {
    envoiImpossible: 'No se ha podido enviar el comentario',
    titre: 'Comentarios',
    vide: 'Ningún comentario',
    videAide: 'Sé el primero en reaccionar a esta publicación.',
  },
  composer: {
    impossible: 'No se ha podido publicar',
    titre: 'Nueva publicación',
    publier: 'Publicar',
    lieu: 'Lugar',
    evenement: 'Evento',
    photoJointe: 'Foto adjunta a la publicación',
    retirerPhoto: 'Quitar la foto',
    visible: 'Visible para todo el servidor',
    remplacerPhoto: 'Cambiar la foto',
    ajouterPhoto: 'Añadir una foto',
    ajouterLieu: 'Añadir un lugar',
    joindreEvenement: 'Adjuntar un evento',
    ajouterCeLieu: 'Añadir este lugar',
    retirerLieu: 'Quitar el lugar',
    termine: 'Hecho',
    retirer: 'Quitar',
    quelEvenement: '¿Qué evento?',
    aucunEvenement: 'Ningún evento próximo',
    aucunEvenementAide: 'Crea uno desde la pestaña Eventos.',
    quoiDeNeuf: (lieu: string) => `¿Qué hay de nuevo en ${lieu}?`,
    lieuChoisi: (lieu: string) => `Lugar: ${lieu}`,
    evenementChoisi: (titre: string) => `Evento: ${titre}`,
    ouDans: (lieu: string) => `¿Dónde en ${lieu}?`,
  },
  ecran: {
    vues: {
      pourToi: 'Para ti',
      recent: 'Reciente',
    },
    supprime: 'Publicación borrada.',
    rechercher: 'Buscar una publicación…',
    rechercherLabel: 'Buscar en el feed',
    ecrire: 'Escribir una publicación',
    masquerQ: '¿Ocultar esta publicación?',
    masquer: 'Ocultar esta publicación',
    aucunResultat: 'Ningún resultado',
    vide: 'El feed todavía está vacío',
    videAide: 'Sé el primero en iniciar una conversación en este servidor.',
    premierPost: 'Escribir la primera publicación',
    rienNeCorrespond: (recherche: string) => `Nada coincide con «${recherche}» en este servidor.`,
  },
  mesPosts: {
    titre: 'Mis publicaciones',
    voirQuiAAime: 'Ver a quién le ha gustado',
    jaime: 'Me gusta',
    personne: 'A nadie le ha gustado todavía esta publicación.',
    vide: 'Ninguna publicación',
    videAide: 'Tus publicaciones aparecerán aquí.',
    compte: (n: number) => `${n} publicaci${n === 1 ? 'ón' : 'ones'}`,
  },
};
